import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { api } from 'app/api'
import { OrgId } from 'app/common/types/id'

import {
  GET_SIGNATORES,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/schools/signatories/get'

import { orgsFilterSelection } from './orgsFilter'

type Signatores = Array<ItemType>

class CafeteriaManagerSignatoresFilterDataBox extends DataBox<Signatores> {}

export const defaultCafeteriaManagerSignatores: Signatores = []
export const cafeteriaManagerSignatoresFilter = createDataBox(
  'cafeteriaManagerSignatoresFilter',
  defaultCafeteriaManagerSignatores,
  CafeteriaManagerSignatoresFilterDataBox,
)

export const defaultCafeteriaManagerSignatoresDataReceiver = async (
  orgsSelection?: Array<string>,
) => {
  const orgIds = orgsSelection || orgsFilterSelection.getData() || [null]
  const orgId = orgIds[0]
  if (!orgId) return []

  const res = await api.request(GET_SIGNATORES, {
    error: 'Не удалось получить данные зав. производством',
    params: {
      orgId: orgId as OrgId,
    },
    convertions: {
      convertParams,
      convertResult,
    },
  })
  return res
    ? res.cafeteriaManagers.map(({ id, person }) => ({
        id: String(id),
        title: person.lastFirstMiddle,
      }))
    : []
}

cafeteriaManagerSignatoresFilter.addDataReceiver(defaultCafeteriaManagerSignatoresDataReceiver)

export const defaultCafeteriaManagerSignatoresSelection: Array<string> = []
export const cafeteriaManagerSignatoresFilterSelection = createDataBoxDefault<Array<string>>(
  'cafeteriaManagerSignatoresFilterSelection',
  defaultCafeteriaManagerSignatoresSelection,
)
